var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReferFriends = function SvgReferFriends(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#refer_friends_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "#EFE",
    rx: 37.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125A42",
    d: "M51 54.05H24v4.433h27z"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 13.5,
    fill: "#92DE63",
    transform: "matrix(-1 0 0 1 37.5 42.968)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92DE63",
    d: "m45.191 16.948 3.621-3.622L29.258-6.228l-3.621 3.621z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "refer_friends_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "#fff",
    rx: 37.5
  })))));
};
export { SvgReferFriends as ReactComponent };
export default __webpack_public_path__ + "images/refer_friends.svg";